import {
    GetBulkUploadDirectUriPayload,
    PendingBulkUploadFile,
    SendBulkUploadFilesDirectPayload,
    UpdateBulkUploadFileStatusPayload
} from './bulk-upload.model';

/**
 * Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export class InitializeBulkUpload {
    static readonly type = '[Bulk Upload] Initialize';
}

export class SetBulkUploadFeatureName {
    static readonly type = '[Bulk Upload] Set feature type';

    constructor(public featureName: string) {}
}

export class AddBulkUploadFile {
    static readonly type = '[Bulk Upload] Add file for bulk upload';

    constructor(public file: File) {}
}

export class RemoveBulkUploadFile {
    static readonly type = '[Bulk Upload] Remove file from pending uploads';

    constructor(public name: string) {}
}

export class SendBulkUploadFiles {
    static readonly type = '[Bulk Upload] Send files to storage';
}

export class ResetBulkUploadFiles {
    static readonly type = '[Bulk Upload] Reset upload state';
}

export class UpdateBulkUploadFileStatus {
    static readonly type = '[Bulk Upload] Update upload status';

    constructor(public payload: UpdateBulkUploadFileStatusPayload) {}
}

export class PostBulkUploadFile {
    static readonly type = '[Bulk Upload] Post file to server';

    constructor(public payload: PendingBulkUploadFile) {}
}

export class RequestBulkUploadDirectUri {
    static readonly type = '[Bulk Upload] Request direct URI to storage provider';

    constructor(public payload: PendingBulkUploadFile) {}
}


export class SendBulkUploadFilesDirect {
    static readonly type = '[Bulk Upload] Send files via direct upload URI';

    constructor(public payload: SendBulkUploadFilesDirectPayload) {}
}

export class GetBulkUploadDirectUri {
    static readonly type = '[Bulk Upload] Get direct URI';

    constructor(public payload: GetBulkUploadDirectUriPayload) {}
}
